interface ICalculateATRsProps {
  candles: number[][];
  period: number;
}

// ATRPreferAvg calculates average true range indicator value for the recent candle
function ATRPreferAvg(period: number, candles: number[][]) {
  if (period === 1) {
    return TR(0, candles);
  }

  if (candles.length < period) {
    throw new Error(
      `Candles not enough to calculate ATR, expected minimum=${period}, optimum=${
        2 * period - 1
      }, but got ${candles.length}`,
    );
  }

  if (candles.length >= 2 * period - 1) {
    return atr(2 * (period - 1), period - 1, period, candles);
  }

  return atr(candles.length - 1, candles.length - period, period, candles);
}

function atr(start: number, end: number, period: number, candles: number[][]) {
  let sum = 0.0;

  for (let i = start; i >= end; i--) {
    sum += TR(i, candles);
  }
  let res = sum / period;

  for (let i = end - 1; i >= 0; i--) {
    res = (res * (period - 1) + TR(i, candles)) / period;
  }
  return res;
}

// TR calculates true range indicator value for specified candle `idx`
function TR(idx: number, candles: number[][]) {
  if (idx === candles.length - 1) {
    return candles[idx][2] - candles[idx][3];
  }

  return Math.max(
    candles[idx][2] - candles[idx][3],
    Math.max(
      Math.abs(candles[idx][2] - candles[idx + 1][4]),
      Math.abs(candles[idx][3] - candles[idx + 1][4]),
    ),
  );
}

export const calculateATRs = ({ candles, period }: ICalculateATRsProps) => {
  const n = candles.length;

  if (n <= period) return [];

  const ATRS: number[] = [];

  for (let i = period; i <= candles.length; i++) {
    const _candles = candles.slice(0, i).reverse();

    const atr = ATRPreferAvg(period, _candles);

    const atrFormatted = Number(atr.toFixed(18));

    ATRS.push(atrFormatted);
  }

  return ATRS;
};
